// extracted by mini-css-extract-plugin
export var containerFullWidth = "styles-module--containerFullWidth---+PWa";
export var containerHalfWidth = "styles-module--containerHalfWidth--IQT2-";
export var link = "styles-module--link--e6eVF";
export var text = "styles-module--text--ZOAtZ";
export var textCol = "styles-module--textCol--tFGYA";
export var textWrapper = "styles-module--textWrapper--PQ4H0";
export var withoutSpace = "styles-module--withoutSpace--4yNO3";